document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("fullscreen-modal");
  const closeBtn = document.getElementById("close-modal");
  const modalOpen = document.getElementById("open-modal");
  const customizer = document.querySelector(".modal-content .customizer");
  const overview_list = document.querySelector(".overview-list");
  const headerElement = document.querySelector(".halo-header");
  const headerElementmobile = document.querySelector(".halo-header-mobile");
  const header_sticky = document.querySelector(".header-sticky");

  // 🔹 Make adjustModal globally accessible
  window.adjustModal = function adjustModal() {
    if (!modal) return;

    //   Choose header based on visibility/height
    let activeHeader = headerElement;
    if (!activeHeader || activeHeader.offsetHeight === 0) {
      activeHeader = headerElementmobile;
    }
    if (!activeHeader) return;

    // Remove sticky/sidebar from the chosen header
    activeHeader.classList.remove('has_sticky', 'is_sidebar');
    headerElement.classList.add('view_increase');

    // Show modal
    modal.style.display = "flex";
    if (customizer) customizer.style.display = "flex";
    document.body.classList.add("overflow_hidden");

    // Open overview list after delay
    if (overview_list) {
      setTimeout(() => {
        overview_list.classList.add("openchilds");
      }, 200);
    }

    const headerHeight = activeHeader.offsetHeight;
    const headerStickyHeight = header_sticky?.offsetHeight || 0;

    modal.style.top = (headerHeight - 1) + "px";
    modal.style.height = `calc(100% - ${headerHeight - 1}px)`;

    console.log("Active header:", activeHeader);
    console.log("Header height:", headerHeight);
    console.log("Sticky header height:", headerStickyHeight);
  };

  // 🔹 Close modal
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      setTimeout(() => {
        modal.style.display = "none";
        modal.style.height = "0";
        document.body.classList.remove("overflow_hidden");
        headerElement.classList.remove('view_increase');
      }, 200);
    });
  }

  // 🔹 Open modal on click
  if (modalOpen) {
    modalOpen.addEventListener("click", () => {
      setTimeout(window.adjustModal, 50);
    });
  }

  // 🔹 Adjust modal on scroll or resize (only if modal is already open)
  ["scroll", "resize"].forEach(evt => {
    window.addEventListener(evt, () => {
      if (modal.style.display === "flex") {
        window.adjustModal();
      }
    });
  });
});

// sub options 
// select all required option 
function checkRequiredOptionsAndToggleButton(buttonSelector = '.btn-next-tab') {
  const requiredItems = document.querySelectorAll('.required-option');
  const allSelected = Array.from(requiredItems).every(item => item.classList.contains('select'));

  const button = document.querySelector(buttonSelector);
  if (button) {
    button.disabled = !allSelected;
    button.classList.toggle('disabled', !allSelected); // Optional: add styling
  }
}
if (document.querySelector('.card-stack')) {
  document.querySelector('.card-stack').addEventListener('click', function () {
    const contrastOptions = document.querySelectorAll('.overview-list.style-list .contrast-options');
    const makeSelections = document.querySelectorAll('.card-stack-text');
    const optionCard = this.querySelector('.option-card'); 
    const second = this.querySelector('.second'); 
    const thrid = this.querySelector('.thrid'); 
    const scrollParent = this.closest(".overview-list")
    if (contrastOptions.length <= 3 || !makeSelections.length) return;

    const delayPerItem = 0;

    // State based on 4th element (first 3 always visible)
    const isShowing = contrastOptions[3].classList.contains('hidden'); 

    if (isShowing) {
      // SHOW
      contrastOptions.forEach((el, index) => {
        if (index < 3) {
          // first 3 → only toggle "show", never hidden
          setTimeout(() => {
            el.classList.add('show');
          }, index * delayPerItem);
        } else {
          setTimeout(() => {
            el.classList.remove('hidden');
            el.classList.add('show');
          }, (index - 3) * delayPerItem + 3 * delayPerItem);
        }
      });
    } else {
      // HIDE
      contrastOptions.forEach((el, index) => {
        if (index < 3) {
          // first 3 → only remove "show", never hidden
          setTimeout(() => {
            el.classList.remove('show');
          }, index * (delayPerItem / 2));
        } else {
          setTimeout(() => {
            el.classList.remove('show');
            el.classList.add('hidden');
          }, (index - 3) * (delayPerItem / 2));
        }
      });
    }

    // Toggle button state
    this.classList.toggle('active', isShowing);
    makeSelections[0].textContent = isShowing ? 'HIDE' : 'SHOW MORE';
   if (window.innerWidth < 450 && optionCard) {
      if (second) second.style.display = isShowing ? 'none' : 'block';
      if (thrid) thrid.style.display = isShowing ? 'none' : 'block';
            if (scrollParent) {
    if (isShowing) {
      // scroll to bottom after small delay (optional)
      setTimeout(() => {
        scrollParent.scrollTo({
          top: scrollParent.scrollHeight,
          behavior: 'smooth'
        });
        console.log('Scrolling to bottom:', scrollParent.scrollHeight);
      }, 500); // <-- delay in milliseconds
    }
  }




      optionCard.style.width = isShowing ? '100%' : '80%';
      optionCard.style.transition = 'width 0.3s ease';

    }
    makeSelections.forEach(el => {
      el.style.background = isShowing
        ? '#4eb74e'
        : 'linear-gradient(0deg,rgba(112, 112, 112, 1) 0%, rgba(20, 21, 22, 1) 40%)';
    });
  });
}

const all_child_tabs = document.querySelectorAll('.customizer-list.childs-list');
const main_tab = document.querySelector('.overview-list');
const apply_btn = document.querySelector('.apply_btn');
const nextToSizeBtn = document.querySelector('.btn-next-tab');
// const nextToSizeBtn = document.querySelector('.btn-next-tab');
const prev_tab = document.querySelector('.btn-prev-tab');
const currently_open_option = document.querySelector('.currently_open_option');
apply_btn.addEventListener('click', function () {
  prev_tab.classList.remove("summary-page")
  currently_open_option.classList.add('hidden');
  // Hide and disable the apply button
  apply_btn.classList.add('hidden', 'disabled');
  prev_tab.classList.add('disabled');
// currently_open_option.innerHTML = ""
  // Hide all child tabs
  all_child_tabs.forEach(tab => tab.classList.add('hidden'));

  // Show the main tab and next button
  main_tab.classList.remove('openchilds');
  main_tab.classList.remove('hidden');
  nextToSizeBtn.classList.remove('hidden');
        setTimeout(  ()=>{
          main_tab.classList.add('openchilds')
        }, 200 )
});
// --- Handle Radio Change ---
// function handleRadioChange(event) {
//   const input = event.target;
//   const apply_btn = document.querySelector('.apply_btn');

//   // Enable Apply button
//   apply_btn?.classList.remove('disabled');

//   // Store selected input ID (not value)
//   apply_btn.dataset.lastSelected = input.id;
//   console.log("input changed:", input.id);
//   const data_main_parent = input.getAttribute('data-main-parent')
//   console.log("input data-main-parent:",data_main_parent);
//   console.log("input data-main-parent:",data_main_parent);
//   const all_related_input = document.querySelectorAll('input[data-main-parent="${data_main_parent}"]')
//   all_related_input.checked = false
// if (prev_tab.classList.contains('summary-page')) {
//   console.log("test click")
//   apply_btn.classList.remove('hidden');
//   nextToSizeBtn.classList.add('hidden');
// }
//   updatePrice();
// }
function handleRadioChange(event) {
  const input = event.target;
  const apply_btn = document.querySelector('.apply_btn');

  // Enable Apply button
  apply_btn?.classList.remove('disabled');

  // Store selected input ID (not value)
  apply_btn.dataset.lastSelected = input.id;
  console.log("input changed:", input.id);

  const data_main_parent = input.getAttribute('data-main-parent');
  console.log("input data-main-parent:", data_main_parent);
  
  // Uncheck all related inputs first
  const all_related_inputs = document.querySelectorAll(`input[data-main-parent="${data_main_parent}"]:checked`);
  console.log("all_related_inputs:", all_related_inputs);
  all_related_inputs.forEach(el => {
    if (el !== input) el.checked = false;
  });

  if (prev_tab.classList.contains('summary-page')) {
    console.log("test click");
    apply_btn.classList.remove('hidden');
    nextToSizeBtn.classList.add('hidden');
  }

  updatePrice();
}


// --- Apply Selections ---
function applySelections() {
  const lastSelectedId = this.dataset.lastSelected;
  if (!lastSelectedId) return;

  const input = document.getElementById(lastSelectedId);
  if (!input) return;

  // --- Get attributes ---
  const selectedParentId = input.getAttribute('data-main-parent');
  const allselection = input.getAttribute('all-selection');
  const selectOptions = input.getAttribute('select-options');
  const card_send = input.getAttribute('card-send');
  const currentTitle = input.getAttribute('current-title');
  const endstep = input.getAttribute('end-step');
  const selectParent = input.getAttribute('data-parent');
  const selectImg = input.getAttribute('select-img');
  const why_not_name = input.getAttribute('style_name');
  const restrictedOptionIdsStr = input.getAttribute('restricted_option_ids');
  const restricted_option_Pid = input.getAttribute('restricted_option_Pid');
  const has_depended = input.getAttribute('has-depended');

  console.log("selectedParentId", selectedParentId);

  // --- Restriction logic ---
  const restrictedOptionIds = restrictedOptionIdsStr
    ? restrictedOptionIdsStr.replace(/[\[\]\s"]/g, '').split(',')
    : [];
  hasOptions(restrictedOptionIds, restricted_option_Pid, selectedParentId, why_not_name);

  // --- UI selection visuals ---
  const parentLi = document.querySelector(`li[data-id="${selectedParentId}"]`);
  if (parentLi) {
    parentLi.querySelector('.icon-check-circle')?.classList.add('active');
    parentLi.querySelector('.selected')?.classList.remove('hidden');
    parentLi.querySelector('.option-card')?.classList.add('select');

    const parent_img = parentLi.querySelector('.select_img img');
    const org_img = parentLi.querySelector('.org_img');

    if (parent_img && org_img) {
      org_img.classList.add('hidden');
      parent_img.parentElement.classList.remove('hidden');
      parent_img.onerror = () => {
        parent_img.src = selectImg;
      };
      parent_img.src = selectImg;
    }

    const nameElement = parentLi.querySelector('.name');
    const top = parentLi.querySelector('.top');
    const bottom = parentLi.querySelector('.bottom');

    if (nameElement && top && bottom) {
      nameElement.innerHTML = selectOptions;
      nameElement.classList.remove('hidden');
      top.classList.remove('hidden');
      bottom.classList.add('hidden');
    }

    parentLi.setAttribute('card-send', `[${card_send}]`);
    parentLi.setAttribute('options-selected', `[${allselection}]`);
    parentLi.setAttribute('summary-edit', `[${selectParent}]`);
    parentLi.setAttribute('current-title', `[${currentTitle}]`);
    parentLi.setAttribute('end-step', `[${endstep}]`);
    parentLi.classList.add('selected_options');

    if (typeof checkRequiredOptionsAndToggleButton === 'function') {
      checkRequiredOptionsAndToggleButton();
    }
  }

  console.log("  Applied radio:", input.id);

  //   Mark this input as applied
  input.setAttribute('data-applied', 'true');

  // Disable Apply until user changes again
  this.classList.add('disabled');
  delete this.dataset.lastSelected;
}
// --- Remove Applied Selection by ID ---
function removeAppliedSelectionById(inputId) {
  const input = document.getElementById(inputId);
  if (!input) return;

  const parentId = input.getAttribute('data-main-parent');
  const parentLi = document.querySelector(`li[data-id="${parentId}"]`);
  if (parentLi) {
    parentLi.classList.remove('selected_options');
    parentLi.removeAttribute('card-send');
    parentLi.removeAttribute('options-selected');
    parentLi.removeAttribute('summary-edit');
    parentLi.removeAttribute('current-title');
    parentLi.removeAttribute('end-step');

    parentLi.querySelector('.icon-check-circle')?.classList.remove('active');
    parentLi.querySelector('.selected')?.classList.add('hidden');
    parentLi.querySelector('.option-card')?.classList.remove('select');

    const nameElement = parentLi.querySelector('.name');
    const top = parentLi.querySelector('.top');
    const bottom = parentLi.querySelector('.bottom');
    if (nameElement && top && bottom) {
      nameElement.innerHTML = '';
      nameElement.classList.add('hidden');
      top.classList.add('hidden');
      bottom.classList.remove('hidden');
    }

    const parent_img = parentLi.querySelector('.select_img img');
    const org_img = parentLi.querySelector('.org_img');
    if (parent_img && org_img) {
      parent_img.parentElement.classList.add('hidden');
      org_img.classList.remove('hidden');
    }
  }

  //   Only uncheck if input is NOT inside .monogram_options or .create-size
  if (!input.closest('.monogram_options') && !input.closest('.create-size')) {
  input.checked = false;
}


  input.removeAttribute('data-applied');
  updatePrice();

  console.log(`  Removed applied selection for input ID: ${inputId}`);
}
// --- Update Price ---
// function updatePrice() {
//   const priceContainers = document.querySelectorAll('.custom_price');
//   const cardPriceContainers = document.querySelectorAll('.card_custom_price');
//   const customizer_additional_charges = document.querySelector('.customizer_additional_charges input');

//   if (priceContainers.length === 0) return;

//   const basePriceAttr = priceContainers[0].getAttribute('default-price');
//   const basePriceStr = basePriceAttr?.replace(/Rs\./i, '').replace(/,/g, '').trim();
//   const basePrice = parseFloat(basePriceStr);

//   if (isNaN(basePrice)) {
//     console.error("Invalid base price:", basePriceAttr);
//     return;
//   }

//   let totalCharges = basePrice;
//   let monoCharges = 0;

//   document.querySelectorAll('input[type="radio"]:checked').forEach(checkedInput => {
//     const charge = parseFloat(checkedInput.getAttribute('more-charges'));
//     if (!isNaN(charge)) {
//       totalCharges += charge;
//     }
//   });

//   priceContainers.forEach(container => {
//     container.innerHTML = `<span>Total: Rs ${totalCharges.toLocaleString()}</span>`;
//     container.setAttribute("customizer-mono-price", monoCharges.toFixed());
//     container.setAttribute("total-price", totalCharges.toLocaleString());
//   });

//   cardPriceContainers.forEach(container => {
//     container.innerHTML = `<span>Rs. ${totalCharges.toLocaleString()}</span>`;
//     container.setAttribute('data-base-price', totalCharges.toLocaleString());
//     container.setAttribute("customizer-mono-price", monoCharges.toFixed());
//     container.setAttribute("total-price", totalCharges.toLocaleString());
//   });

//   if (customizer_additional_charges) {
//     customizer_additional_charges.value = `${totalCharges - basePrice}`;
//   }

//   console.log("  Price updated:", totalCharges);
// }
function updatePrice() {
  const priceContainers = document.querySelectorAll('.custom_price');
  const cardPriceContainers = document.querySelectorAll('.card_custom_price');
  const customizer_additional_charges = document.querySelector('.customizer_additional_charges input');

  if (priceContainers.length === 0) return;

  // 1) Detect currency + extract numeric price
  const basePriceAttr = priceContainers[0].getAttribute('default-price') || "";
  const currencyMatch = basePriceAttr.match(/^[^\d]+/);   // currency before numbers
  const currency = currencyMatch ? currencyMatch[0].trim() : "";   // e.g. "Rs.", "$", "AED"
  
  const basePriceStr = basePriceAttr.replace(/^[^\d]+/, "").replace(/,/g, "").trim();
  const basePrice = parseFloat(basePriceStr);

  if (isNaN(basePrice)) {
    console.error("Invalid base price:", basePriceAttr);
    return;
  }

  let totalCharges = basePrice;
  let monoCharges = 0;

  // 2) Add additional charges from checked radio buttons
  document.querySelectorAll('input[type="radio"]:checked').forEach(checkedInput => {
    const charge = parseFloat(checkedInput.getAttribute('more-charges'));
    if (!isNaN(charge)) totalCharges += charge;
  });

  // 3) Update main price containers
  priceContainers.forEach(container => {
    container.innerHTML = `<span>Total: ${currency} ${totalCharges.toLocaleString()}</span>`;
    container.setAttribute("customizer-mono-price", monoCharges.toFixed());
    container.setAttribute("total-price", totalCharges.toLocaleString());
  });

  // 4) Update card price containers
  cardPriceContainers.forEach(container => {
    container.innerHTML = `<span>${currency} ${totalCharges.toLocaleString()}</span>`;
    container.setAttribute("data-base-price", totalCharges.toLocaleString());
    container.setAttribute("customizer-mono-price", monoCharges.toFixed());
    container.setAttribute("total-price", totalCharges.toLocaleString());
  });

  // 5) Update hidden extra charge input
  if (customizer_additional_charges) {
    customizer_additional_charges.value = `${totalCharges - basePrice}`;
  }

  console.log("Price updated:", currency, totalCharges);
}


// --- Clear Last Picked Radio on Prev Tab ---
function clearLastSelected() {
  const apply_btn = document.querySelector('.apply_btn');
  if (!apply_btn) return;

  const lastSelectedId = apply_btn.dataset.lastSelected;
  if (lastSelectedId) {
    removeAppliedSelectionById(lastSelectedId);
    console.log("  Cleared selection by ID:", lastSelectedId);
  }

  delete apply_btn.dataset.lastSelected;
  apply_btn.classList.add('disabled');
  checkRequiredOptionsAndToggleButton()
}
// --- Event Listeners ---
document.querySelectorAll('input[type="radio"]').forEach(input => {
  input.addEventListener('change', function (e) {
    handleRadioChange(e);

    if (prev_tab && prev_tab.classList.contains('summary-page')) {
      prev_tab.classList.add('disabled');
    }
    const mono_prev_tab  = document.querySelector('.mono-prev-tab ');
    if (this.closest('.monogram_options') && mono_prev_tab) {
      mono_prev_tab.classList.add('mono-change');
    }

    // If this input was previously applied but now unchecked → remove it
    if (!this.checked && this.hasAttribute('data-applied')) {
      removeAppliedSelectionById(this.id);
    }

    // Also check for any applied inputs that got unchecked programmatically
    document.querySelectorAll('input[type="radio"][data-applied="true"]').forEach(appliedInput => {
      if (!appliedInput.checked) {
        removeAppliedSelectionById(appliedInput.id);
      }
    });
  });
});
document.querySelector('.apply_btn')?.addEventListener('click', applySelections);
document.querySelectorAll('.btn-prev-tab, .mono-prev-tab').forEach(btn =>
  btn.addEventListener('click', clearLastSelected)
);

// restricted and depended options  
function hasOptions(restrictedOptionIds = [], restricted_option_Pid, selectedParentId, why_not_name) {
  const allLis = document.querySelectorAll('li[child-id], li[data-id]');
  const restrictedSet = new Set(restrictedOptionIds.map(String)); // normalize as strings
  console.log(" restrictedOptionIds:", restrictedOptionIds);
  console.log(" restricted_option_Pid:", restricted_option_Pid);
  console.log(" selectedParentId:", selectedParentId);
  console.log(" why_not_name:", why_not_name);
  // Remove previous disabled items related to the selected parent
   const monogram_tab = document.querySelector(".custom_monogram");


   document.querySelectorAll('li.hasdisabled').forEach(li => {
  //   Skip if inside monogram_tab
  if (monogram_tab && monogram_tab.contains(li)) return;

  if (li.getAttribute('hasdisabled-to') === selectedParentId) {
    li.classList.remove('hasdisabled');
    li.removeAttribute('hasdisabled-to');

    const why_not = li.querySelector('.why_not');
    if (why_not) why_not.textContent = '';

    const optionCard = li.querySelector('.option-card');
    const name = li.querySelector('.name');
    const top = li.querySelector('.top');
    const bottom = li.querySelector('.bottom');

    optionCard?.classList.remove('select');
    name?.classList.remove('hidden');
    top?.classList.remove('hidden');
    bottom?.classList.add('hidden');
  }
});

  
  // Disable restricted options (both parents and children)
  allLis.forEach(li => {
    // Check both child-id (for children) and data-id (for parents)
    const childId = li.getAttribute('child-id');
    const parentId = li.getAttribute('data-id');
    const elementId = childId || parentId;
    if (restrictedSet.has(elementId)) {
      li.classList.add('hasdisabled');
      li.setAttribute('hasdisabled-to', selectedParentId);
      console.log(" Disabled:", elementId, "(Type:", childId ? "child" : "parent", ")");
      const why_not = li.querySelector('.why_not');
      if (why_not) {
        why_not.textContent = `Can't choose this option with ${why_not_name}`;
      }
      // Apply visual changes to the disabled element
      const optionCard = li.querySelector('.option-card');
      const name = li.querySelector('.name');
      const top = li.querySelector('.top');
      const bottom = li.querySelector('.bottom');
      optionCard?.classList.remove('select');
      name?.classList.add('hidden');
      top?.classList.add('hidden');
      bottom?.classList.remove('hidden');
      // Uncheck related inputs based on element type
      if (parentId && restrictedSet.has(parentId)) {
        // This is a parent being disabled - uncheck inputs related to this parent
        document.querySelectorAll(`input[data-main-parent="${parentId}"]`).forEach(input => {
          input.checked = false;
        });
      } else if (childId && restrictedSet.has(childId)) {
        // This is a child being disabled - uncheck inputs related to the restricted_option_Pid
        document.querySelectorAll(`input[data-main-parent="${restricted_option_Pid}"]`).forEach(input => {
          input.checked = false;
        });
      }
    }
  });
  // Additional logic: If restricted_option_Pid is provided, handle its specific visual state
  if (restricted_option_Pid) {
    const parentLi = document.querySelector(`li[data-id="${restricted_option_Pid}"]`);
    if (parentLi) {
      const optionCard = parentLi.querySelector('.option-card');
      const name = parentLi.querySelector('.name');
      const top = parentLi.querySelector('.top');
      const bottom = parentLi.querySelector('.bottom');
      optionCard?.classList.remove('select');
      name?.classList.add('hidden');
      top?.classList.add('hidden');
      bottom?.classList.remove('hidden');
    }
  }
  // Restore dependent options
  const dependedLi = document.querySelector(`li[data-id="${selectedParentId}"]`);
  if (dependedLi?.querySelector('.option-card')) {
    document.querySelectorAll(`input[has-depended="${selectedParentId}"]`).forEach(input => {
      input.parentElement?.classList.remove('hasdisabled');
    });
  }
}

const mainstyleLists = document.querySelector('.overview-list.style-list');


let currentIndex = null;
let currentListClass = '';

// Handle childs option on click
document.addEventListener('click', function (e) {
  const clickedLi = e.target.closest('li[data-list]');
  const info = e.target.matches('.info_btn');
  const modal_dialog = e.target.matches('.modal') || e.target.closest('.modal');
  const close_btn = e.target.matches('.close_btn');

  if (!clickedLi) return;
  if (info) return;
  if (modal_dialog) return;

  const dataList = clickedLi.getAttribute('data-list');
  const mainparent = clickedLi.getAttribute('data-id');
  const index = parseInt(clickedLi.getAttribute('current_index'));
  const total_options = parseInt(clickedLi.getAttribute('sub-options'));
  const childsIn = clickedLi.getAttribute('childsIn');
  const subTitle = clickedLi.getAttribute('sub-title') || clickedLi.getAttribute('contras_name') || '';

  //   Moved currently_open_option UI update here
  if (typeof currently_open_option !== 'undefined') {
    currently_open_option.classList.remove('hidden');
    currently_open_option.innerHTML = `<h4>${subTitle} : </h4> <span> (step ${index } of ${total_options + index - 1 })</span>`;
  }
  if (!prev_tab.classList.contains('summary-page')) {
  console.log("test click")
  apply_btn.classList.remove('hidden');
  nextToSizeBtn.classList.add('hidden');
}

  if (!dataList || isNaN(index) || !childsIn) return;

  const dataIds = dataList.split(',').map(id => id.trim());

  // Call getnewList but without UI updates inside
  getnewList(index, total_options, childsIn, subTitle, mainparent, dataIds);

  prev_tab.classList.remove('disabled');
  mainstyleLists.classList.add('hidden');

  const removescroll = e.target.closest(".product_form_wrapper");
  if (removescroll) {
    removescroll.scrollTop = 0;
  }
});

let stepSubtitles = {};

function getnewList(index, total_options, childsIn, subTitle, mainparent, dataIds = []) {
  currentIndex = index;
  currentListClass = childsIn;
  stepSubtitles[index] = subTitle;

  // Hide all lists first
  const allCustomizerLists = document.querySelectorAll('.customizer-list.childs-list');
  allCustomizerLists.forEach(list => {
    list.classList.add('hidden');
    list.classList.remove('openchilds');
  });

  const targetUL = document.querySelector(`.${childsIn}[data-index="${index}"]`);
  if (!targetUL) return;

  targetUL.setAttribute('data-scroll', targetUL.scrollTop);
  setTimeout(() => { targetUL.scrollTop = 0 }, 500);
  targetUL.classList.remove('hidden');
  setTimeout(() => targetUL.classList.add('openchilds'), 200);

  // Show/hide children
  const childListItems = targetUL.querySelectorAll('li[child-id]');
  childListItems.forEach(childLi => {
    const childId = childLi.getAttribute('child-id');
    const parentId = childLi.getAttribute('parent-id');
    const shouldShow =
      dataIds.includes(childId) ||
      dataIds.includes(parentId) ||
      parentId === mainparent;
    childLi.classList.toggle('hidden', !shouldShow);
  });

  //   Removed currently_open_option update from here
}



const myTabContent = document.querySelector("#myTabContent");
const Sizes = document.querySelector('.create-size');
const custom_summary_page = document.querySelector('.custom_summary_page');
const hide_selection = document.querySelectorAll('.hide_selection');
const styles = document.querySelector('.overview');
// const prev_tab = document.querySelector('.btn-prev-tab'); // make sure this exists

nextToSizeBtn.addEventListener('click', () => {
  // First move from styles to sizes
  

  // Then, if Sizes is now visible, show the summary next
  if (!Sizes.classList.contains('hidden')) {
    Sizes.classList.add('hidden');

    hide_selection.forEach(el => el.classList.add('hidden'));
    
    custom_summary_page.classList.remove('hidden');
    summary_styles()
  }else{
    styles.classList.add('hidden');
  Sizes.classList.remove('hidden');
  prev_tab.classList.remove('disabled');
  nextToSizeBtn.classList.add('disabled');
  myTabContent.classList.add('hidden');
  nextToSizeBtn.innerHTML="Review & BUY";
    validateSizeInputs()
  }
     custom_hidden.forEach(el => { el.classList.add("custom_hide");});
});



// Prev button handler
if (prev_tab) {
  prev_tab.addEventListener('click', function (e) {
    e.preventDefault();

    // 🟡 Handle summary-page mode first
    if (prev_tab.classList.contains('summary-page')) {
      Sizes.classList.add('hidden');
      custom_summary_page.classList.remove('hidden');
hide_selection.forEach(el => el.classList.add('hidden'));
      custom_hidden.forEach(el => {
        el.classList.add('custom_hide');
      });

      styles.classList.add('hidden');
      myTabContent.classList.add('hidden');
      return; // stop further processing
    }

    // 🟢 Regular previous step logic
    if (!Sizes.classList.contains('hidden')) {
      Sizes.classList.add('hidden');
      styles.classList.remove('hidden');
      myTabContent.classList.remove('hidden');
      prev_tab.classList.add('disabled');
      nextToSizeBtn.classList.remove('disabled');
      nextToSizeBtn.innerHTML = "Next";
      custom_hidden.forEach(el => { el.classList.remove("custom_hide"); });
      return;
    }

    if (currentIndex === null || currentIndex <= 0) return;

    const prevIndex = currentIndex - 1;

    const currentUL = document.querySelector(`.${currentListClass}[data-index="${currentIndex}"]`);
    if (currentUL) {
      currentUL.classList.add('hidden');
      currentUL.classList.remove('openchilds');
    }

    const prevUL = document.querySelector(`.${currentListClass}[data-index="${prevIndex}"]`);
    if (prevUL) {
      prevUL.classList.remove('hidden');
      setTimeout(() => prevUL.classList.add('openchilds'), 200);
      currentIndex = prevIndex;

      //   Restore subtitle from memory
      const prevSubTitle = stepSubtitles[prevIndex] || "";
      if (prevIndex >= 1) {
        currently_open_option.innerHTML = `<h4>${prevSubTitle} :</h4> <span> Step( ${prevIndex + 1} of 4 )</span>`;
        currently_open_option.classList.remove('hidden');
      } else {
        prev_tab.classList.add('disabled');
        nextToSizeBtn.classList.remove('hidden');
        apply_btn.classList.add('hidden');
        currently_open_option.classList.add('hidden');
        // currently_open_option.innerHTML = ""; 
      }
    }
  });
}


// Alert
// Track if checkout is clicked

(function () {
  let checkoutClicked = false;

  // Helper to check if modal is open
  function isModalOpen() {
    const m = document.getElementById('fullscreen-modal');
    if (!m) return false;
    return getComputedStyle(m).display === 'flex' || m.classList.contains('model-open') || m.hasAttribute('data-open');
  }

  // Mark checkout clicked to skip alert
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart__submit[name="checkout"], [data-checkout], button[name="checkout"]')) {
      checkoutClicked = true;
    }
  });

  // Main part: triggers when the user leaves, reloads, closes tab, or switches browser/app
  window.addEventListener('beforeunload', function (e) {
    if (isModalOpen() && !checkoutClicked) {
      // Required by modern browsers to show the default leave confirmation
      e.preventDefault();
      e.returnValue = ''; 
      return ''; 
    }
  });
})();


// sizes tabs flow 
document.querySelectorAll('.create-size-list a').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    e.preventDefault();
 
    const clickedId = anchor.getAttribute('id'); // Get the ID from the clicked <a>
    const tabContainer = document.getElementById('myTabContent3');

    tabContainer.querySelectorAll('div').forEach(div => {
      if (div.id === clickedId) {
        div.classList.add('active', 'show');
        validateSizeInputs()
      } else {
        div.classList.remove('active', 'show');
      }
    });
  });
});

// smart sizes tabs
  const questions = document.querySelectorAll(".question_sizes");
  const prevBtn = document.querySelector(".prev_size");
  const nextBtn = document.querySelector(".next_size");
  const skipBtns = document.querySelectorAll(".skip_question");
const modalOpen = document.getElementById("open-modal");
  let currentIndexquestion = 0;
if (modalOpen) {
  
  function updateView() {
    questions.forEach((q, i) => {
      q.classList.toggle("hidden", i !== currentIndexquestion);
    });

    prevBtn.classList.toggle("disabled", currentIndexquestion === 0);
    nextBtn.classList.toggle("disabled", currentIndexquestion === questions.length - 1);

    skipBtns.forEach(btn => {
      btn.classList.toggle("disabled", currentIndexquestion === questions.length - 1);
    });
  }

  function goToNext() {
    if (currentIndexquestion < questions.length - 1) {
      currentIndexquestion++;
      updateView();
    }
  }
  if (prevBtn) {
    
  prevBtn.addEventListener("click", function () {
    if (currentIndexquestion > 0) {
      currentIndexquestion--;
      updateView();
    }
  });
  }
  if (nextBtn) {
    
  nextBtn.addEventListener("click", goToNext);
  }

  if (skipBtns) {
    
  skipBtns.forEach(btn => {
    btn.addEventListener("click", goToNext);
  });
  }

  // updateView(); // Initial render
}



  const adjust_monoscroll = document.querySelector(".main-customizer-new .product_form_wrapper");
  const monogram_li = document.querySelector("a.monogram");
  const custom_hidden = document.querySelectorAll(".image_and_btn.fabric_box, .modal-close");
  // monogram 
document.addEventListener("DOMContentLoaded", function () {
  // DOM Elements
  
  const monogram_li_select = monogram_li?.querySelector(".selected");
  const monogram_tab = document.querySelector(".custom_monogram");
  const commonly_btn = document.querySelector(".commonly");
  const specific_mono_btn = document.querySelector(".specific_mono");
  const apply_mono_btn = document.querySelector(".apply_mono_btn");
  const styles = document.querySelector(".styles");
  const myTabContent = document.querySelector("#myTabContent");

  const questions = document.querySelectorAll(".mono-input-box");
  const mono_prev_tab = document.querySelector(".mono-prev-tab");
  const mono_next_tab = document.querySelector(".mono-next-tab");
  const apply_mono_addons = document.querySelector(".apply-mono-addons");
  const mono_prev_addons = document.querySelector(".mono-prev-addons");
  const mono_next_addons = document.querySelector(".mono-next-addons");
  const remove_mono_selection = document.querySelector(".remove-monogram");

  let currentIndex = 0;

  if (
    !monogram_li ||
    !monogram_tab ||
    !commonly_btn ||
    !specific_mono_btn ||
    !apply_mono_btn ||
    !styles ||
    !questions.length
  ) return;

  // Show Monogram Tab
  monogram_li.addEventListener("click", () => {
    adjust_monoscroll.style.overflow= "hidden"
    custom_hidden.forEach(el => { el.classList.add("custom_hide");});
    apply_mono_btn.classList.add("hidden");
    styles.classList.add("hidden");
    monogram_tab.classList.remove("hidden");
    commonly_btn.classList.add("hidden");
    myTabContent.classList.add("hidden");
    specific_mono_btn.classList.remove("hidden");
    currentIndex = 0;
    console.log('woekjasd')
    updateMonoView();
  });
  
  // Apply Monogram
  apply_mono_btn.addEventListener("click", () => {
    all_child_tabs.forEach(tab => tab.classList.add('hidden'));
    adjust_monoscroll.style.overflow= "auto"
    apply_mono_btn.classList.add("hidden");
    monogram_li.classList.add("select");
    monogram_li_select?.classList.remove("hidden");
    custom_hidden.forEach(el => { el.classList.remove("custom_hide");});
 updatePrice();
  mono_prev_tab.classList.remove("mono-change");
  commonly_btn.classList.remove("hidden");
  myTabContent.classList.remove("hidden");
  specific_mono_btn.classList.add("hidden");
  monogram_tab.classList.add("hidden");
  styles.classList.remove("hidden");

  const monogramfont = document.querySelector("input[name='properties[monogram_font]']:checked");
  const monogramcolor = document.querySelector("input[name='properties[monogram_color]']:checked");
  const monogramposition = document.querySelector("input[name='properties[monogram_position]']:checked");

  console.log("monogramfont", monogramfont);
  console.log("monogramcolor", monogramcolor);
  console.log("monogramposition", monogramposition);

  const titleEl = monogram_li.querySelector(".custom-title");
  const bottomtitle = monogram_li.querySelector(".title.bottom");
  const toptitle = monogram_li.querySelector(".title.top");
  const selections = monogram_li.querySelector(".selections");
  const imgWrapper = monogram_li.querySelector(".img");
  const imgEl = imgWrapper?.querySelector("img");

  if (monogramfont && monogramcolor && monogramposition && imgEl && imgWrapper && titleEl && bottomtitle && selections) {
    const fontImg = monogramfont.getAttribute("font-img");
    const fontname = monogramfont.value;
    const colorname = monogramcolor.value;
    const fontposition = monogramposition.value;
    const monogramContainer = document.querySelector('.custom_monogram');
    const textInputs = monogramContainer.querySelectorAll('input[name="mono"]');
  const textValues = Array.from(textInputs)
    .map(input => input.value.trim())
    .filter(val => val !== '');

    titleEl.classList.add("hidden");
    bottomtitle.classList.add("hidden");
    toptitle.classList.remove("hidden");
    imgWrapper.classList.remove("hidden");
    imgEl.src = fontImg;

   selections.innerHTML = `${textValues.join(' ')}<br>${fontname}, ${colorname}, ${fontposition}`;

  }
});


  function updateMonoView() {
    questions.forEach((q, i) => {
  const isCurrent = i === currentIndex;
  
  q.classList.toggle("hidden", !isCurrent);
  
  const child = q.querySelector(".customizer-list");
  if (child) {
    setTimeout ( ()=>{
    
    child.classList.toggle("openchilds", isCurrent);
  },200 )
  }
});


    const isLast = currentIndex === questions.length - 1;
    const monoisLast = currentIndex === questions.length - 5 ;
    const checkedInputs = monogram_tab.querySelectorAll("input[type='radio']:checked, input[type='checkbox']:checked");
    const textInput = monogram_tab.querySelector("input[type='text']");
    const stepflow = monogram_tab.querySelector(".steps_flow");
    const isTextFilled = textInput && textInput.value.trim() !== "";
    const isValid = checkedInputs.length === 3 && isTextFilled;
console.log("isValid",isValid)
   let currentstep = currentIndex + 1;

const popupLabels = ["Initial", "Design", "Color", "Position"];
let currentpopup = popupLabels[currentstep - 1] || "Unknown";

stepflow.innerHTML = `<p>${currentpopup} ( Step ${currentstep} of 4 )</p>`;


    // Show/hide apply button
    apply_mono_btn.classList.toggle("hidden", !(isLast && isValid));

    // Top next button
    mono_next_tab?.classList.toggle("hidden", isLast && isValid);
    mono_next_tab?.classList.toggle("disabled", isLast && !isValid);
    // Disable footer prev if first step
    mono_prev_addons?.classList.toggle("disabled", currentIndex === 0);
    // mono_next_addons?.classList.toggle("disabled",currentIndex === 3 && !isValid);
    // mono_next_addons?.classList.toggle("hidden",currentIndex === 3 && isValid);
    // apply-mono-addons?.classList.toggle("hidden",currentIndex === 3 && isValid);
    const isLastStep = currentIndex === 3;

mono_next_addons?.classList.toggle("disabled", isLastStep && !isValid);
mono_next_addons?.classList.toggle("hidden", isLastStep && isValid);
apply_mono_addons?.classList.toggle("hidden", !(isLastStep && isValid));
  }

  function goToNext() {
    if (currentIndex < questions.length - 1) {
      currentIndex++;
      updateMonoView();
      console.log("currentIndex",currentIndex , questions.length)
    }
  }

  function goToPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      updateMonoView();
    } else {
      const modal = document.getElementById("fullscreen-modal");
          if (modal.style.display === "flex") {
          adjustModal();
          console.log("adjustModal")
             } 
            // Return to styles tab only from .mono-prev-tab (not from .mono-prev-addons)
            monogram_tab.classList.add("hidden");
            styles.classList.remove("hidden");
            myTabContent.classList.remove("hidden");
            commonly_btn.classList.remove("hidden");
            specific_mono_btn.classList.add("hidden");
            custom_hidden.forEach(el => { el.classList.remove("custom_hide");});
            const adjust_monoscroll = document.querySelector(".main-customizer-new .product_form_wrapper");
            adjust_monoscroll.style.overflow= "auto"
          const monogramOptions = document.querySelector('.monogram_options');
          const mainmonoli = document.querySelector('.adjut_monogram');
      const mono_selected = mainmonoli.querySelector('.option-card');
      const mono_selection = mainmonoli.querySelector('.selections ');
      // if (mono_prev_tab && mono_prev_tab.classList.contains('mono-change')) {
      //   prev_tab.classList.add('disabled');
      //   mono_selected.classList.remove("select");
      //   mono_selection.innerHTML = "";

      //   let extramonocharges = 0;

      //   if (monogramOptions) {
      //     const checkedInputs = monogramOptions.querySelectorAll('input.customizer:checked');
      //     console.log("checkedInputs", checkedInputs.length, checkedInputs);

      //     // ✅ First calculate charges — don't uncheck inside this loop
      //     checkedInputs.forEach(input => {
      //       const charge = parseFloat(input.getAttribute('more-charges')) || 0;
      //       extramonocharges += charge;
      //     });

      //     // ✅ Then uncheck in a separate step
      //     checkedInputs.forEach(input => {
      //       input.checked = false;
      //     });
      //   }

      //   console.log("Total extra charges:", extramonocharges);

      //   // monogram prices
      //   const priceContainers = document.querySelectorAll('.custom_price');
      //   const cardPriceContainers = document.querySelectorAll('.card_custom_price');
      //   const customizer_additional_charges = document.querySelector('.customizer_additional_charges input');

      //   if (priceContainers.length === 0) return;

      //   const basePriceAttr = priceContainers[0].getAttribute('default-price');
      //   const basePriceStr = basePriceAttr?.replace(/Rs\./i, '').replace(/,/g, '').trim();
      //   const basePrice = parseFloat(basePriceStr);

      //   if (isNaN(basePrice)) {
      //     console.error("Invalid base price:", basePriceAttr);
      //     return;
      //   }

      //   let totalCharges = basePrice;
      //   let monoCharges = 0;

      //   // ✅ Add charges from selected radios
      //   document.querySelectorAll('input[type="radio"]:checked').forEach(checkedInput => {
      //     const charge = parseFloat(checkedInput.getAttribute('more-charges'));
      //     if (!isNaN(charge)) {
      //       totalCharges += charge;
      //     }
      //   });

      //   // ✅ Subtract extra mono charges only once
      //   // totalCharges -= extramonocharges;

      //   // Update price containers
      //   priceContainers.forEach(container => {
      //     container.innerHTML = `<span>Total: Rs ${totalCharges.toLocaleString()}</span>`;
      //     container.setAttribute("customizer-mono-price", monoCharges.toFixed());
      //     container.setAttribute("total-price", totalCharges.toLocaleString());
      //   });

      //   cardPriceContainers.forEach(container => {
      //     container.innerHTML = `<span>Rs. ${totalCharges.toLocaleString()}</span>`;
      //     container.setAttribute('data-base-price', totalCharges.toLocaleString());
      //     container.setAttribute("customizer-mono-price", monoCharges.toFixed());
      //     container.setAttribute("total-price", totalCharges.toLocaleString());
      //   });

      //   if (customizer_additional_charges) {
      //     customizer_additional_charges.value = `${totalCharges - basePrice}`;
      //   }

      //   console.log("Final total after subtracting extra mono charges:", totalCharges);

      // }
        if (mono_prev_tab && mono_prev_tab.classList.contains('mono-change')) {
          mainmonoli.querySelector('.custom-title').classList.remove("hidden")
           mainmonoli.querySelector('.img').classList.add("hidden")
          prev_tab.classList.add('disabled');
          mono_selected.classList.remove("select");
          mono_selection.innerHTML = "";

          let extramonocharges = 0;

          if (monogramOptions) {
            const checkedInputs = monogramOptions.querySelectorAll('input.customizer:checked');
            console.log("checkedInputs", checkedInputs.length, checkedInputs);

            // ✅ First collect mono charges
            checkedInputs.forEach(input => {
              const charge = parseFloat(input.getAttribute('more-charges')) || 0;
              extramonocharges += charge;
            });

            // ✅ Then uncheck
            checkedInputs.forEach(input => {
              input.checked = false;
            });
          }

          console.log("Total extra charges:", extramonocharges);

          // ─────────────────────────────────
          //   ✅ MULTI-CURRENCY PRICE
          // ─────────────────────────────────
          const priceContainers = document.querySelectorAll('.custom_price');
          const cardPriceContainers = document.querySelectorAll('.card_custom_price');
          const customizer_additional_charges = document.querySelector('.customizer_additional_charges input');

          if (priceContainers.length === 0) return;

          const basePriceAttr = priceContainers[0].getAttribute('default-price') || "";

          // ✅ Detect currency (ANY non-digit prefix)
          const currencyMatch = basePriceAttr.match(/^[^\d]+/);
          const currency = currencyMatch ? currencyMatch[0].trim() : "";   // example: Rs., $, €, AED

          const basePriceStr = basePriceAttr
            .replace(/^[^\d]+/, "")   // remove currency
            .replace(/,/g, "")        // remove commas
            .trim();

          const basePrice = parseFloat(basePriceStr);

          if (isNaN(basePrice)) {
            console.error("Invalid base price:", basePriceAttr);
            return;
          }

          let totalCharges = basePrice;
          let monoCharges = 0;

          // ✅ Add charges from selected radios
          document.querySelectorAll('input[type="radio"]:checked').forEach(checkedInput => {
            const charge = parseFloat(checkedInput.getAttribute('more-charges'));
            if (!isNaN(charge)) {
              totalCharges += charge;
            }
          });

          // ✅ Remove monogram component
          // if needed → uncomment
          // totalCharges -= extramonocharges;

          // ─────────────────────────────────
          //   ✅ Update price UI
          // ─────────────────────────────────
          priceContainers.forEach(container => {
            container.innerHTML = `<span>Total: ${currency} ${totalCharges.toLocaleString()}</span>`;
            container.setAttribute("customizer-mono-price", monoCharges.toFixed());
            container.setAttribute("total-price", totalCharges.toLocaleString());
          });

          cardPriceContainers.forEach(container => {
            container.innerHTML = `<span>${currency} ${totalCharges.toLocaleString()}</span>`;
            container.setAttribute('data-base-price', totalCharges.toLocaleString());
            container.setAttribute("customizer-mono-price", monoCharges.toFixed());
            container.setAttribute("total-price", totalCharges.toLocaleString());
          });

          if (customizer_additional_charges) {
            customizer_additional_charges.value = `${totalCharges - basePrice}`;
          }

          console.log("Final total after subtracting extra mono charges:", totalCharges);
        }



    
    
    }

}

  // Top navigation
  mono_prev_tab?.addEventListener("click", (e) => {
    e.preventDefault();
    goToPrev();
  });

  mono_next_tab?.addEventListener("click", (e) => {
    e.preventDefault();
    if (!mono_next_tab.classList.contains("disabled")) {
      goToNext();
    }
  });

  // Footer navigation (does not return to styles tab)
  mono_prev_addons?.addEventListener("click", (e) => {
    e.preventDefault();
    if (currentIndex > 0) {
      currentIndex--;
      updateMonoView();
    }
  });
  // remove monogram selection 
  remove_mono_selection?.addEventListener("click", (e) => {
   const modal = document.getElementById("fullscreen-modal");
          if (modal.style.display === "flex") {
          adjustModal();
          console.log("adjustModal")
             } 
            // Return to styles tab only from .mono-prev-tab (not from .mono-prev-addons)
            monogram_tab.classList.add("hidden");
            styles.classList.remove("hidden");
            myTabContent.classList.remove("hidden");
            commonly_btn.classList.remove("hidden");
            specific_mono_btn.classList.add("hidden");
            custom_hidden.forEach(el => { el.classList.remove("custom_hide");});
            const adjust_monoscroll = document.querySelector(".main-customizer-new .product_form_wrapper");
            adjust_monoscroll.style.overflow= "auto"
          const monogramOptions = document.querySelector('.monogram_options');
          const mainmonoli = document.querySelector('.adjut_monogram');
           mainmonoli.querySelector('.custom-title').classList.remove("hidden")
           mainmonoli.querySelector('.img').classList.add("hidden")
      const mono_selected = mainmonoli.querySelector('.option-card');
      const mono_selection = mainmonoli.querySelector('.selections ');
        prev_tab.classList.add('disabled');
        mono_selected.classList.remove("select");
        mono_selection.innerHTML = "";

        let extramonocharges = 0;

        if (monogramOptions) {
          const checkedInputs = monogramOptions.querySelectorAll('input.customizer:checked');
          console.log("checkedInputs", checkedInputs.length, checkedInputs);

          // ✅ First calculate charges — don't uncheck inside this loop
          checkedInputs.forEach(input => {
            const charge = parseFloat(input.getAttribute('more-charges')) || 0;
            extramonocharges += charge;
          });

          // ✅ Then uncheck in a separate step
          checkedInputs.forEach(input => {
            input.checked = false;
          });
        }

        console.log("Total extra charges:", extramonocharges);

        // monogram prices
        const priceContainers = document.querySelectorAll('.custom_price');
        const cardPriceContainers = document.querySelectorAll('.card_custom_price');
        const customizer_additional_charges = document.querySelector('.customizer_additional_charges input');

        if (priceContainers.length === 0) return;

        // const basePriceAttr = priceContainers[0].getAttribute('default-price');
        // const basePriceStr = basePriceAttr?.replace(/Rs\./i, '').replace(/,/g, '').trim();
        // const basePrice = parseFloat(basePriceStr);
        const basePriceAttr = priceContainers[0].getAttribute('default-price') || "";
        const currencyMatch = basePriceAttr.match(/^[^\d]+/);   // currency before numbers
        const currency = currencyMatch ? currencyMatch[0].trim() : "";   // e.g. "Rs.", "$", "AED"
        
        const basePriceStr = basePriceAttr.replace(/^[^\d]+/, "").replace(/,/g, "").trim();
        const basePrice = parseFloat(basePriceStr);
        if (isNaN(basePrice)) {
          console.error("Invalid base price:", basePriceAttr);
          return;
        }

        let totalCharges = basePrice;
        let monoCharges = 0;

        // ✅ Add charges from selected radios
        document.querySelectorAll('input[type="radio"]:checked').forEach(checkedInput => {
          const charge = parseFloat(checkedInput.getAttribute('more-charges'));
          if (!isNaN(charge)) {
            totalCharges += charge;
          }
        });

        // ✅ Subtract extra mono charges only once
        // totalCharges -= extramonocharges;

        // Update price containers
        priceContainers.forEach(container => {
          container.innerHTML = `<span>Total: $ ${totalCharges.toLocaleString()}</span>`;
          container.setAttribute("customizer-mono-price", monoCharges.toFixed());
          container.setAttribute("total-price", totalCharges.toLocaleString());
        });

        cardPriceContainers.forEach(container => {
          container.innerHTML = `<span>$. ${totalCharges.toLocaleString()}</span>`;
          container.setAttribute('data-base-price', totalCharges.toLocaleString());
          container.setAttribute("customizer-mono-price", monoCharges.toFixed());
          container.setAttribute("total-price", totalCharges.toLocaleString());
        });

        if (customizer_additional_charges) {
          customizer_additional_charges.value = `${totalCharges - basePrice}`;
        }

        console.log("Final total after subtracting extra mono charges:", totalCharges);
      
  });

  mono_next_addons?.addEventListener("click", (e) => {
    e.preventDefault();
    if (!mono_next_addons.classList.contains("disabled")) {
      goToNext();
  
    }
  });

  // Validate on input change
  monogram_tab.addEventListener("input", function () {
    if (currentIndex === questions.length - 5 || currentIndex === questions.length - 1) {
      updateMonoView();
    }
  });

  updateMonoView(); // Initial render
});

 const inputs = document.querySelectorAll("#letterInputs input");
const previewBox = document.getElementById("previewBox");

// Restrict to alphanumeric only
inputs.forEach(input => {
  input.addEventListener("input", () => {
    input.value = input.value.replace(/[^A-Z0-9.&]/gi, "").toUpperCase();
    updatePreview();
    if (input.nextElementSibling) {
      input.nextElementSibling.focus();
    }
  });
});

function updatePreview() {
  const text = Array.from(inputs)
    .map(input => input.value)
    .join(" ")
    .trim();
  previewBox.textContent = text;
}

document.addEventListener("DOMContentLoaded", function () {
  const previewBox = document.getElementById("previewBox");
  const letterInputs = document.querySelectorAll("#letterInputs input[type='text']");

  // Live update text in preview
  function updatePreviewText() {
    const letters = Array.from(letterInputs).map(input => input.value.toUpperCase());
    previewBox.textContent = letters.join(" ");
  }

  letterInputs.forEach(input => {
    input.addEventListener("input", updatePreviewText);
  });

  // Update text color
  document.querySelectorAll("input.mono-color").forEach(input => {
    input.addEventListener("change", function () {
      const color = this.getAttribute("data-color");
      if (color) {
        previewBox.style.color = color;
      }
    });
  });

  // Update font
      // document.querySelectorAll("input.mono-font").forEach(input => {
      // input.addEventListener("change", function () {
      //   const googleFont = this.getAttribute("data-google-font");
      //   const customFont = this.getAttribute("data-custom-font");
      //   const customFontname = this.value;

      //   let fontFamily = "";

      //   // If it's a valid Google font link (full URL)
      //   if (googleFont?.includes("fonts.googleapis.com")) {
      //     if (!document.querySelector(`link[data-font="${googleFont}"]`)) {
      //       const link = document.createElement("link");
      //       link.rel = "stylesheet";
      //       link.href = googleFont;
      //       link.setAttribute("data-font", googleFont);
      //       document.head.appendChild(link);
      //     }

      //     const match = googleFont.match(/family=([^:&]+)/);
      //     fontFamily = match ? decodeURIComponent(match[1].replace(/\+/g, " ")) : "";
      //   }

      //   // If it's just the font name (like "Roboto"), build the link
      //   else if (googleFont && !googleFont.includes("http")) {
      //     const fontLink = `https://fonts.googleapis.com/css2?family=${googleFont.replace(/ /g, '+')}`;
      //     if (!document.querySelector(`link[data-font="${fontLink}"]`)) {
      //       const link = document.createElement("link");
      //       link.rel = "stylesheet";
      //       link.href = fontLink;
      //       link.setAttribute("data-font", fontLink);
      //       document.head.appendChild(link);
      //     }

      //     fontFamily = googleFont;
      //   }

      //   // Handle custom fonts
      //   else if (customFont) {
      //     const styleTag = document.getElementById("custom-font-style") || document.createElement("style");
      //     styleTag.id = "custom-font-style";
      //     styleTag.innerHTML = `
      //       @font-face {
      //         font-family: `${customFontname}`;
      //         src: url('${customFont}');
      //       }
      //     `;
      //     document.head.appendChild(styleTag);
      //     fontFamily = `${customFontname}`;
      //   }

      //   // Apply the font
      //   if (fontFamily) {
      //     document.getElementById("previewBox").style.fontFamily = `'${fontFamily}', sans-serif`;
      //   }
      // });
      // });
      document.querySelectorAll("input.mono-font").forEach(input => {
  input.addEventListener("change", function () {
    const googleFont = this.getAttribute("data-google-font");
    const customFont = this.getAttribute("data-custom-font");
    const customFontname = this.value.trim();

    let fontFamily = "";

    // ✅ Case 1: Full Google Fonts URL
    if (googleFont?.includes("fonts.googleapis.com")) {
      if (!document.querySelector(`link[data-font="${googleFont}"]`)) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = googleFont;
        link.setAttribute("data-font", googleFont);
        document.head.appendChild(link);
      }

      const match = googleFont.match(/family=([^:&]+)/);
      fontFamily = match ? decodeURIComponent(match[1].replace(/\+/g, " ")) : "";
    }

    // ✅ Case 2: Font name only (e.g., "Roboto")
    else if (googleFont && !googleFont.includes("http")) {
      const fontLink = `https://fonts.googleapis.com/css2?family=${googleFont.replace(/ /g, '+')}`;
      if (!document.querySelector(`link[data-font="${fontLink}"]`)) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = fontLink;
        link.setAttribute("data-font", fontLink);
        document.head.appendChild(link);
      }

      fontFamily = googleFont;
    }

    // ✅ Case 3: Custom font file URL
    else if (customFont) {
      let styleTag = document.getElementById("custom-font-style");
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = "custom-font-style";
        document.head.appendChild(styleTag);
      }

      styleTag.innerHTML = `
        @font-face {
          font-family: '${customFontname}';
          src: url('${customFont}');
        }
      `;

      fontFamily = customFontname;
    }

    // ✅ Apply font to preview box
    if (fontFamily) {
      const preview = document.getElementById("previewBox");
      if (preview) {
        preview.style.fontFamily = `'${fontFamily}', sans-serif`;
      }
    }
  });
});


  // Initialize on page load
  // updatePreviewText();
});

// show selection of all selected option 
function summary_styles() {
  const selectedStyleContainer = document.querySelector('.summary_style');
  const selectedAdditionalContainer = document.querySelector('.summary_additional');
  const summary_form = document.querySelector('.summary_form');

  // Clear visual tags
  selectedStyleContainer.innerHTML = '';
  selectedAdditionalContainer.innerHTML = '';

  // 🔄 Clear only hidden inputs from summary_form
  summary_form.querySelectorAll('input[type="hidden"]').forEach(input => input.remove());

  // 1. Styles and Contrasts
  const selectedLis = document.querySelectorAll('li.selected_options');
  selectedLis.forEach((li, index) => {
    let value = li.getAttribute('options-selected');
    let cardData = li.getAttribute('card-send');
    let reSelect = li.getAttribute('summary-edit');
    let current_title = li.getAttribute('current-title');
    let selection_steps = li.getAttribute('end-step');
let styleName = li.getAttribute('style_name') || li.getAttribute('contras_name');
    const childType = li.getAttribute('childsin'); // "styles" or "contrasts"

    if (value) {
      value = value.replace(/^\[+|\]+$/g, '').trim();
      cardData = cardData.replace(/^\[+|\]+$/g, '').trim();
      reSelect = reSelect.replace(/^\[+|\]+$/g, '').trim();
      current_title = current_title.replace(/^\[+|\]+$/g, '').trim();
      selection_steps = selection_steps.replace(/^\[+|\]+$/g, '').trim();
      if (value === '') return;

      const tag = document.createElement('div');
      tag.className = 'tag';
      tag.innerHTML = `${value} <span reselection="${reSelect}" reselection-step="${selection_steps}" option-title="${current_title}" class="edit-btn">Edit✎</span>`;

      if (childType === 'styles') {
        selectedStyleContainer.appendChild(tag);
      } else if (childType === 'contrasts') {
        selectedAdditionalContainer.appendChild(tag);
      }

      const input = document.createElement('input');
      input.type = 'hidden';
      // input.name = `properties[${childType}_${index}]`;
      input.name = `properties[${styleName}]`;
      input.value = cardData;
      // input.value = value;
      summary_form.appendChild(input);
    }
  });

  // 2. Monogram Section
  const summary_monogram = document.querySelector('.summary_monogram');
  const monogramContainer = document.querySelector('.custom_monogram');
  summary_monogram.innerHTML = '';

  // Text inputs
  const textInputs = monogramContainer.querySelectorAll('input[name="mono"]');
  const textValues = Array.from(textInputs)
    .map(input => input.value.trim())
    .filter(val => val !== '');

  if (textValues.length > 0) {
    const textTag = document.createElement('div');
    textTag.classList.add('tag');
    textTag.innerHTML = `Text: ${textValues.join(' ')} <span class="edit-btn mono">Edit✎</span>`;
    summary_monogram.appendChild(textTag);

    const textInput = document.createElement('input');
    textInput.type = 'hidden';
    textInput.name = `properties[monogram_text]`;
    textInput.value = textValues.join(' ');
    summary_form.appendChild(textInput);
  }

  // Checked radios & checkboxes
  const checkedInputs = monogramContainer.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
  checkedInputs.forEach(input => {
    const name = input.name;
    const value = input.value;

    const tagDiv = document.createElement('div');
    tagDiv.classList.add('tag');
    tagDiv.innerHTML = `${name}: ${value} <span class="edit-btn mono">Edit✎</span>`;
    summary_monogram.appendChild(tagDiv);

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = name;
    hiddenInput.value = value;
    summary_form.appendChild(hiddenInput);
  });

  // 3. Sizes Section

const summary_sizes = document.querySelector('.summary_sizes');
const selected_sizes = Sizes.querySelector('.active.show');
const size_tab_links = Sizes.querySelectorAll('.create-size-list a');

summary_sizes.innerHTML = '';

//   Get active tab name
let active_tab_name = '';
size_tab_links.forEach(link => {
  if (link.classList.contains('active')) {
    active_tab_name = link.innerText.trim();
  }
});

//   Append heading if tab name exists
if (active_tab_name) {
  const tabHeading = document.createElement('span');
  tabHeading.classList.add('summary_title');
  tabHeading.textContent = `${active_tab_name} :`;
  summary_sizes.appendChild(tabHeading);

  //   Create hidden input for active tab name
  const hiddenTabInput = document.createElement('input');
  hiddenTabInput.type = 'hidden';
  hiddenTabInput.name = 'properties[Measurments]';
  hiddenTabInput.value = active_tab_name;
  summary_form.appendChild(hiddenTabInput);
}

//   Get selected inputs (radio, checkbox, number)
const allInputs = selected_sizes.querySelectorAll(
  'input[type="radio"]:checked, input[type="checkbox"]:checked, input[type="number"]'
);

allInputs.forEach(input => {
  const type = input.type;
  const name = input.name;
  const value = input.value.trim();

  if (type === 'number' && value === '') return;

  //   Create visible tag
  const tagDiv = document.createElement('div');
  tagDiv.classList.add('tag');
  tagDiv.innerHTML = `${name}: ${value} <span class="edit-btn sizes">Edit✎</span>`;
  summary_sizes.appendChild(tagDiv);

  //   Create hidden input for form submission
  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  hiddenInput.name = `properties[${name}]`;
  hiddenInput.value = value;
  summary_form.appendChild(hiddenInput);
});


}


// start again
const start_again_buttons = document.querySelectorAll('.start-button');
const monogram_tabs = document.querySelectorAll(".mono-input-box");
const card_stack =document.querySelector('.card-stack')
start_again_buttons.forEach(startBtn => {
  startBtn.addEventListener('click', () => {
    // Disable the next button initially
    nextToSizeBtn.classList.add('disabled');
    nextToSizeBtn.innerHTML= "NEXT";
    const selections = document.querySelector(".selections");
    selections .innerHTML= "";
    
   myTabContent.classList.remove('hidden');
    // If the stack is active, simulate click to collapse
    if (card_stack.classList.contains('active')) {
      card_stack.click();
    }

    // 1. Remove "select" class from all option cards
    main_tab.querySelectorAll('a.select').forEach(a => a.classList.remove('select'));

    // 2. Remove all 'hasdisabled' classes
    document.querySelectorAll('li').forEach(li => li.classList.remove('hasdisabled'));

    // 3. Add back 'hasdisabled' where has-depended exists with a value
    document.querySelectorAll('li').forEach(li => {
      const attrValue = li.getAttribute('has-depended');
      if (attrValue && attrValue.trim() !== '') {
        li.classList.add('hasdisabled');
      }
    });

    // 4. Reset all display elements
    main_tab.querySelectorAll('.name').forEach(el => {
      el.innerHTML = "";
      el.classList.add('hidden');
    });

    main_tab.querySelectorAll('.top').forEach(el => el.classList.add('hidden'));
    main_tab.querySelectorAll('.bottom').forEach(el => el.classList.remove('hidden'));
    main_tab.querySelectorAll('.select_img').forEach(el => el.classList.add('hidden'));
    main_tab.querySelectorAll('.org_img').forEach(el => el.classList.remove('hidden'));

    // 5. Uncheck inputs in child tabs and Sizes
    all_child_tabs.forEach(tab => {
      tab.querySelectorAll('input').forEach(input => input.checked = false);
    });

    Sizes.querySelectorAll('input').forEach(input => input.checked = false);

    // 6. Reset monogram inputs (text, radio, checkbox)
    const mainmonoli = document.querySelector('.adjut_monogram');
         mainmonoli.querySelector('.custom-title').classList.remove("hidden")
           mainmonoli.querySelector('.img').classList.add("hidden")
    monogram_tabs.forEach(box => {
      box.querySelectorAll('input').forEach(input => {
        if (input.type === 'text') {
          input.value = '';
        } else {
          input.checked = false;
        }
      });
    });

    // 7. Hide apply/prev buttons
    apply_btn.classList.add('hidden', 'disabled');
    prev_tab.classList.add('disabled');

    // 8. Clear any selected info display
    // currently_open_option.innerHTML = "";

    // 9. Reset visible tabs
    all_child_tabs.forEach(tab => tab.classList.add('hidden'));
    main_tab.classList.remove('hidden');
    styles.classList.remove('hidden');
    nextToSizeBtn.classList.remove('hidden');
    Sizes.classList.add('hidden');

    // 10. Reset monogram navigation
    document.querySelector(".commonly")?.classList.remove("hidden");
    document.querySelector(".specific_mono")?.classList.add("hidden");
    document.querySelector(".custom_monogram")?.classList.add("hidden");

    // // 11. Optional: Call radio handler with dummy event (if needed)
    // if (typeof handleRadioChange === 'function') {
    //   handleRadioChange({ target: null }); // pass a mock event if needed
    // }
  const priceContainers = document.querySelectorAll('.custom_price');
  console.log("priceContainers", priceContainers);

  // let basePriceAttr = priceContainers[0].getAttribute('default-price');
  // console.log("basePriceAttr (raw)", basePriceAttr);

  // // Remove Rs, commas, and spaces → then parse
  // let basePrice = parseFloat(
  //   basePriceAttr.replace(/Rs\.?/i, "").replace(/,/g, "").trim()
  // );
    const basePriceAttr = priceContainers[0].getAttribute('default-price') || "";
        const currencyMatch = basePriceAttr.match(/^[^\d]+/);   // currency before numbers
        const currency = currencyMatch ? currencyMatch[0].trim() : "";   // e.g. "Rs.", "$", "AED"
        
        const basePriceStr = basePriceAttr.replace(/^[^\d]+/, "").replace(/,/g, "").trim();
        const basePrice = parseFloat(basePriceStr);
        if (isNaN(basePrice)) {
          console.error("Invalid base price:", basePriceAttr);
          return;
        }
  console.log("basePrice (number)", basePrice);

  priceContainers.forEach(container => {
    // Format back with commas
    container.innerHTML = `<span>Total: $ ${basePrice.toLocaleString()}</span>`;
  });



  });
});

// reselection of option through Edit btn
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('edit-btn')) {

      custom_hidden.forEach(el => { el.classList.remove("custom_hide");});
    hide_selection.forEach(el => el.classList.remove('hidden'));

    if (event.target.classList.contains('sizes')) {
      if (custom_summary_page) {
        custom_summary_page.classList.add('hidden');
        Sizes.classList.remove('hidden');
          prev_tab.classList.add('summary-page');
      }
    }else if(event.target.classList.contains('mono')){
        const mono_prev_tab = document.querySelector(".mono-prev-tab");
       styles.classList.remove('hidden');
           mono_prev_tab.classList.add('summary-page');
         custom_summary_page.classList.add('hidden');
              myTabContent.classList.remove('hidden');
      monogram_li.click();
      nextToSizeBtn.innerHTML="NEXT";
      // main_tab.classList.add('ok');
    }else {
      if (styles) {
        const subTitle=event.target.getAttribute("option-title")
        const selection_steps=event.target.getAttribute("reselection-step")
          if (typeof currently_open_option !== 'undefined') {
    currently_open_option.classList.remove('hidden');
    currently_open_option.innerHTML = `<h4>${subTitle} : </h4> <span> (step ${selection_steps } of ${selection_steps } )</span>`;
  }
        nextToSizeBtn.innerHTML="NEXT";
        // prev_tab.classList.add('disabled');
        prev_tab.classList.add('summary-page');
        styles.classList.remove('hidden');
        myTabContent.classList.remove('hidden');
        main_tab.classList.add('hidden');
        custom_summary_page.classList.add('hidden');

        const reselection = event.target.getAttribute('reselection');
        const reselection_steps = event.target.getAttribute('reselection-step');
        console.log('reselection_steps:', reselection_steps);
        console.log('Reselection:', reselection);

        const all_child_tabs = document.querySelectorAll('.customizer-list.childs-list');
        all_child_tabs.forEach(tab => {
          let hasVisibleLi = false;

          const liItems = tab.querySelectorAll('li');
          liItems.forEach(li => {
            const parentId = li.getAttribute('parent-id');
            if (parentId === reselection) {
              li.classList.remove('hidden');
              hasVisibleLi = true;
            } else {
              li.classList.add('hidden');
            }
          });

          if (hasVisibleLi) {
            tab.classList.remove('hidden');
            tab.classList.add('openchilds');
            
          } else {
            tab.classList.add('hidden');
          }
        });
      }
    }

    console.log("click edit");
  }
});




// unchecked sizes radio inputs 
document.querySelectorAll('.create-size input[type="radio"]').forEach(radio => {
  radio.addEventListener('click', function (e) {
    validateSizeInputs()
    // Check if already checked
    if (this.checked) {
      if (this.hasAttribute('data-waschecked')) {
        validateSizeInputs()
        this.checked = false;
        this.removeAttribute('data-waschecked');
      } else {
        validateSizeInputs()
        this.setAttribute('data-waschecked', 'true');
      }

      // Clear others in the same group
      document.querySelectorAll(`.create-size input[type="radio"][name="${this.name}"]`).forEach(other => {
        if (other !== this) {
          other.removeAttribute('data-waschecked');
        }
        validateSizeInputs()
      });
    }
  });
});
// sizes option validation 
function validateSizeInputs(buttonSelector = '.btn-next-tab') {
  const standard_sizes = Sizes.querySelector('.standard.active.show');
  const measure_body = Sizes.querySelector('.measure_body.active.show');
  const smart_sizes = Sizes.querySelector('.smart_sizes');

  //   Collect only those question blocks that do NOT have a .skip_question inside
  const smart_questions = smart_sizes 
    ? Array.from(smart_sizes.querySelectorAll('.question_sizes')).filter(
        q => !q.querySelector('.skip_question')
      )
    : [];

  let allValid = true;

  if (standard_sizes || measure_body) {
    //   Validate active standard or measure section
    const activeSection = standard_sizes || measure_body;
    const inputs = activeSection.querySelectorAll(
      'input[required][type="radio"], input[required][type="number"]'
    );

    const radioNamesChecked = new Set();

    inputs.forEach(input => {
      if (input.type === 'radio') {
        const name = input.name;
        if (!radioNamesChecked.has(name)) {
          radioNamesChecked.add(name);
          const isChecked = activeSection.querySelector(`input[name="${name}"]:checked`);
          if (!isChecked) allValid = false;
        }
      } else if (input.type === 'number') {
        if (input.value.trim() === '') allValid = false;
      }
    });

  } else if (smart_questions.length > 0) {
    //   Validate each smart question individually
    smart_questions.forEach(question => {
      const inputs = question.querySelectorAll(
        'input[required][type="radio"], input[required][type="number"]'
      );

      const radioNamesChecked = new Set();
      let questionValid = true;

      inputs.forEach(input => {
        if (input.type === 'radio') {
          const name = input.name;
          if (!radioNamesChecked.has(name)) {
            radioNamesChecked.add(name);
            const isChecked = question.querySelector(`input[name="${name}"]:checked`);
            if (!isChecked) questionValid = false;
          }
        } else if (input.type === 'number') {
          if (input.value.trim() === '') questionValid = false;
        }
      });

      if (!questionValid) {
        allValid = false;
        question.classList.add('error'); // optional: highlight invalid question
      } else {
        question.classList.remove('error');
      }
    });
  }

  //   Toggle button state and class
  const button = document.querySelector(buttonSelector);
  if (button) {
    button.disabled = !allValid;
    button.classList.toggle('disabled', !allValid);
  }

  console.log("validateSizeInputs", allValid);
  return allValid;
}
  
// Run validation only when inputs inside standard_sizes or measure_body change
Sizes.addEventListener('change', function (e) {
  const standard_sizes = Sizes.querySelector('.standard.active.show');
  const measure_body   = Sizes.querySelector('.measure_body.active.show');

  const activeSection = standard_sizes || measure_body;
  if (!activeSection) return;

  if (
    activeSection.contains(e.target) &&
    (e.target.matches('input[type="radio"]') || e.target.matches('input[type="number"]'))
  ) {
    validateSizeInputs();
  }
});


// Add to cart
function fetchConfig(type = 'json') {
  const config = {
    method: 'POST',
    headers: {
      'Accept': 'application/json'
    }
  };

  if (type === 'json') {
    config.headers['Content-Type'] = 'application/json';
  }

  return config;
}

function normalizeProperties(properties) {
  const normalized = {};
  for (const key in properties) {
    if (!Object.hasOwn(properties, key)) continue;
    normalized[key.trim()] = properties[key];
  }
  return normalized;
}

function buildPayload(cartData) {
  return {
    lineItems: cartData.items
      .map(item => {
        const props = normalizeProperties(item.properties || {});
        const extraPrice = parseFloat(props.additional_price || "0") || 0;

        // if (extraPrice <= 0) return null; // only send when > 0
        if (extraPrice === 0) {
          delete props.additional_price;
        }
        const basePrice = (item.original_price || 0) / 100; 
        const finalUnitPrice = basePrice + extraPrice;

        return {
          originalUnitPrice: basePrice,
          variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
          quantity: item.quantity,
          priceOverride: {
            amount: String(finalUnitPrice),
            currencyCode: "USD"
          },
          customAttributes: Object.entries(props).map(([key, value]) => ({
            key,
            value
          }))
        };
      })
      .filter(Boolean)
  };
}

function sendDraftOrder(cartData, redirect = false) {
  const payload = buildPayload(cartData);
  console.log("📦 Payload to send:", payload);

  return fetch("https://phpstack-1427592-5716770.cloudwaysapps.com/api/create/draft/order/usa", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    .then(apiRes => {
      console.log("  API Response:", apiRes);
      const checkout_url = apiRes.draft_order?.invoiceUrl;

      if (redirect && checkout_url) {
        console.log("  Redirecting to:", checkout_url);
        window.location.href = checkout_url;
      }
    })
    .catch(err => {
      console.error("  Error sending draft order:", err);
      if (redirect) window.location.href = "/checkout"; // fallback
    });
}
//  Add to Cart
document.addEventListener('click', function (evt) {
  const target = evt.target.closest('.add-to-cart') 
              || evt.target.closest('.button-group-bottom .btn[data-add-to-cart]');
  if (!target) return;

  evt.preventDefault();

  const form = target.closest('form');
  if (!form) return;

  const formData = new FormData(form);
  //   Remove additional_price if it's 0
 if (formData.has('properties[additional_price]')) {
    let val = parseFloat(formData.get('properties[additional_price]') || "0");

    if (val === 0) {
      //   remove if 0
      formData.delete('properties[additional_price]');
    } else if (val > 0) {
      //   rewrite with "$"
      formData.set('properties[additional_price]', `${val} $`);
    }
  }
  //   grab textarea value
  const comments = document.getElementById('comments')?.value.trim();
  if (comments) {
    // Shopify requires properties[Name] for custom fields
    formData.append('properties[Additional Comment]', comments);
  }

  formData.append('sections', '');
  formData.append('sections_url', window.location.pathname);

  const config = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  };

  fetch('/cart/add.js', config)
    .then(res => {
      if (!res.ok) throw new Error('Failed to add item to cart');
      return res.json();
    })
    .then(data => {
      if (theme?.HaloAddOn?._setupSideCart) {
        theme.HaloAddOn._setupSideCart();
      }
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cartData => {
      // 👉 here we call API too if needed after add-to-cart
      // return sendDraftOrder(cartData, false);
    })
    .catch(err => {
      console.error('Error adding to cart or sending payload:', err);
    });
});
// checkout button
document.addEventListener('click', function (evt) {
const checkoutBtn = evt.target.closest('.cart__submit[name="checkout"]');
console.log("checkoutbtn",checkoutBtn)
  if (!checkoutBtn) return;

  evt.preventDefault(); // stop default Shopify checkout
  console.log(" Checkout clicked, preparing payload...");

  //   Hide the checkout button
  checkoutBtn.style.display = "none";

  //   Show spinner (make sure .spinner_main exists in DOM)
  const spinner = document.querySelector(".spinner_main");
  if (spinner) {
    spinner.style.display = "flex";
  }
 
  fetch('/cart.js')
    .then(res => res.json())
     .then(cartData => {
    const hasAdditional = cartData.items.some(item => {
      const priceProp = item.properties?.additional_price;
      return priceProp !== undefined && priceProp !== null && priceProp !== '';
    });

    console.log('Has additional price:', hasAdditional);
if(hasAdditional){
  sendDraftOrder(cartData, true);
}else {
        console.log("✅ No additional_price → go to Shopify checkout");
        window.location.href = '/checkout';
      }
  })
    .catch(err => {
      console.error("  Error in checkout API flow:", err);

      //   On error → bring back the button and hide spinner
      checkoutBtn.style.display = "inline-block";
      if (spinner) spinner.style.display = "none";

      window.location.href = "/checkout"; // fallback
    });
});

// text slider
 function applyMarquee() {
    const wrappers = document.querySelectorAll('.scroll-wrapper');

    wrappers.forEach(wrapper => {
      const textElement = wrapper.querySelector('.name') || wrapper.querySelector('.title');
      if (!textElement) return;

      textElement.classList.toggle('animate', textElement.scrollWidth > wrapper.clientWidth)
    });
    const scrollWrappers = document.querySelectorAll('.why-not-scroll');

    scrollWrappers.forEach(wrapper => {
      const textElement = wrapper.querySelector('.why_not') ;
      if (!textElement) return;

      textElement.classList.toggle('animate', textElement.scrollWidth > wrapper.clientWidth)
    });
  

  }
  window.addEventListener('load', applyMarquee);
  window.addEventListener('click', applyMarquee);

// Price increases according to quantity
  const priceContainer = document.querySelector('.card_custom_price');
const quantityInput = document.querySelector('.total_quantity');
const increaseBtn = document.querySelector('.increase');
const decreaseBtn = document.querySelector('.decrease');
// customizer price and quantity
function updateDisplay(quantity) {
  const basePrice = parseFloat(priceContainer.dataset.basePrice.replace(/,/g, ''));
  quantityInput.value = quantity; //   Correct for input
  const totalPrice = basePrice * quantity;
  const formattedPrice = totalPrice.toLocaleString('en-PK');
  priceContainer.querySelector('span').textContent = `$. ${formattedPrice}`;
}

let quantity = parseInt(quantityInput.value) || 1;

increaseBtn.addEventListener('click', () => {
  quantity++;
  updateDisplay(quantity);
});

decreaseBtn.addEventListener('click', () => {
  if (quantity > 1) {
    quantity--;
    updateDisplay(quantity);
  }
});



// monoinputs flow
const monograminputs = document.querySelectorAll('#letterInputs input');

monograminputs.forEach((input, index) => {
  input.addEventListener('input', (e) => {
    const value = e.target.value;

    // Allow only letters (optional)
    // if (!/^[a-zA-Z]$/.test(value)) {
    //   e.target.value = '';
    //   return;
    // }

    // Move to next input if exists
    if (value && index < inputs.length - 1) {
      inputs[index + 1].focus();
    }
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      inputs[index - 1].focus();
    }
  });
});
monograminputs.forEach(input => {
  input.addEventListener('focus', () => {
    input.classList.remove('no-caret'); // show caret
    setTimeout(() => {
      input.classList.add('no-caret'); // hide after delay
    }, 700); // adjust to blink once (~700ms = 1 blink)
  });

  input.addEventListener('blur', () => {
    input.classList.remove('no-caret'); // reset when unfocused
  });
});
// font style according text number 
function updateMonogramTextValue() {
  const monoFonts = document.querySelectorAll('.mono-input-box.fonts li[has-depended]');
  const letterInputs = document.querySelectorAll('input[name="mono"].blink-once');
  const hiddenInput = document.querySelector('input[name="properties[monogram text]"]');

  if (!letterInputs.length || !hiddenInput || !monoFonts.length) return;

  // Step 1: Count filled inputs
  const filledCount = Array.from(letterInputs).filter(input => input.value.trim() !== '').length;

  // Step 2: Loop through each font item and match with its disable limit
  monoFonts.forEach(font => {
    const disableLimitAttr = font.getAttribute('has-depended');
    const disableLimit = parseInt(disableLimitAttr, 10) || 0;

    if (filledCount <= disableLimit) {
      font.classList.remove('hasdisabled');
    } else {
      font.classList.add('hasdisabled');
    }
  });

  // Step 3: Combine values into hidden input
  const combinedValue = Array.from(letterInputs)
    .map(input => input.value.trim())
    .join('');

  hiddenInput.value = combinedValue;

  // Optional: Debug log
  console.log(`Filled: ${filledCount}, Hidden input value: "${hiddenInput.value}"`);
}


// Attach input event to each mono input
document.querySelectorAll('input[name="mono"].blink-once').forEach(input => {
  input.addEventListener('input', updateMonogramTextValue);
});
// save selected options 
document.querySelector('.save-btn').addEventListener('click', function () {
  const form = document.querySelector('.summary_form');
  const inputs = form.querySelectorAll('input');
  const savedSelections = {};

  inputs.forEach(input => {
    // Skip disabled inputs
    if (input.disabled) return;

    const name = input.name;
    const value = input.value;

    // If name already exists (e.g., checkboxes with same name), store as array
    if (savedSelections[name]) {
      if (!Array.isArray(savedSelections[name])) {
        savedSelections[name] = [savedSelections[name]];
      }
      savedSelections[name].push(value);
    } else {
      savedSelections[name] = value;
    }
  });

  // Store in localStorage (or you can send to server if needed)
  localStorage.setItem('savedSelections', JSON.stringify(savedSelections));

  console.log('Selections saved:', savedSelections);
  alert('Selections saved for future order!');
});

// load previous selection 
document.querySelectorAll('.load-button').forEach(button => {
  button.addEventListener('click', function () {
    const savedSelections = JSON.parse(localStorage.getItem('savedSelections'));
    console.log("savedSelections", savedSelections);

    if (!savedSelections) {
      alert("No saved selections found.");
      return;
    }

    const recheckinputs = document.querySelectorAll(
      'input[type="radio"], input[type="checkbox"], input[type="text"], input[type="hidden"], input[type="number"], input[style_name]'
    );
    const sectionCards = document.querySelectorAll('a.option-card[style_name]');
    all_child_tabs.forEach(tab => tab.classList.add('hidden'));

    //   Highlight section headers if saved value found
    sectionCards.forEach(section => {
      const group = section.getAttribute('style_name');
      const savedKey = `properties[${group}]`;
      const savedValue = savedSelections[savedKey] || savedSelections[group];

      console.log("Checking section:", group, "=>", savedValue);

      if (savedValue) {
        section.classList.add('select');
        const showselect = section.querySelector('.selected');
        if (showselect) {
          showselect.classList.remove('hidden');
        }
      }
    });

    //   Match inputs and apply saved values
    recheckinputs.forEach(input => {
      let group = '';
      let value = '';
      let savedKey = '';
      let savedValue = '';

      // Priority 1: all-selection
      if (input.hasAttribute('all-selection')) {
        const allSelection = input.getAttribute('all-selection');
        if (!allSelection.includes(':')) return;
        [group, value] = allSelection.split(':').map(s => s.trim());
      }
      // Priority 2: style_name + name
      else if (input.hasAttribute('style_name') && input.name) {
        group = input.name;
        value = input.getAttribute('style_name');
      }
      // Priority 3: name + value (basic inputs like number/text)
      else if (input.name && input.value !== undefined) {
        group = input.name;
        value = input.value;
      }

      if (!group) return;

      savedKey = `properties[${group}]`;
      savedValue = savedSelections[savedKey] || savedSelections[group]; //   fallback support

      if (!savedValue) return;

      console.log("Checking input:", group, "=>", savedValue);

      if (input.type === 'radio' || input.type === 'checkbox') {
        if (savedValue.includes(value)) {
          input.checked = true;
          //   Trigger visual & logic updates
          if (typeof handleloadprevious === 'function') {
            handleloadprevious({ target: input });
          }
        }
      } else {
        input.value = savedValue;
      }
    });
    function handleloadprevious(event) {
  const input = event.target;
  const selectedParentId = input.getAttribute('data-main-parent');
  const allselection = input.getAttribute('all-selection');
  const selectOptions = input.getAttribute('select-options');
  const card_send = input.getAttribute('card-send');
  const selectParent = input.getAttribute('data-parent');
  const currentTitle = input.getAttribute('current-title');
  const endstep = input.getAttribute('end-step');
  const selectImg = input.getAttribute('select-img');
  const why_not_name = input.getAttribute('style_name');
  const restrictedOptionIdsStr = input.getAttribute('restricted_option_ids');
  const restricted_option_Pid = input.getAttribute('restricted_option_Pid');
  const has_depended = input.getAttribute('has-depended');
  const apply_btn = document.querySelector('.apply_btn');

  apply_btn?.classList.remove('disabled');
// Parse restricted IDs into array
  const restrictedOptionIds = restrictedOptionIdsStr
    ? restrictedOptionIdsStr.replace(/[\[\]\s"]/g, '').split(',')
    : [];
  // console.log("restrictedOptionIds",restrictedOptionIds)
hasOptions(restrictedOptionIds, restricted_option_Pid, selectedParentId, why_not_name)

  // UI selection visuals
  const parentLi = document.querySelector(`li[data-id="${selectedParentId}"]`);
  if (parentLi) {
    parentLi.querySelector('.icon-check-circle')?.classList.add('active');
    parentLi.querySelector('.selected')?.classList.remove('hidden');
    parentLi.querySelector('.option-card')?.classList.add('select');

    const parent_img = parentLi.querySelector('.select_img img');
    const org_img = parentLi.querySelector('.org_img');

    if (parent_img && org_img) {
      org_img.classList.add('hidden');
      parent_img.parentElement.classList.remove('hidden');
      parent_img.onerror = () => {
        parent_img.src = selectImg;
      };
      parent_img.src = selectImg;
      console.log ("selectImg",selectImg )
    }

    const nameElement = parentLi.querySelector('.name');
    const top = parentLi.querySelector('.top');
    const bottom = parentLi.querySelector('.bottom');

    if (nameElement && top && bottom) {
      nameElement.innerHTML = selectOptions;
      nameElement.classList.remove('hidden');
      top.classList.remove('hidden');
      bottom.classList.add('hidden');
    }

    parentLi.setAttribute('card-send', `[${card_send}]`);
    parentLi.setAttribute('options-selected', `[${allselection}]`);
    parentLi.setAttribute('summary-edit', `[${selectParent}]`);
    parentLi.setAttribute('current-title', `[${currentTitle}]`);
    parentLi.setAttribute('end-step', `[${endstep}]`);
    parentLi.classList.add('selected_options');

    if (typeof checkRequiredOptionsAndToggleButton === 'function') {
      checkRequiredOptionsAndToggleButton();
    }
  

  }

//   // Price Update Logic
  const priceContainers = document.querySelectorAll('.custom_price');
  const cardPriceContainers = document.querySelectorAll('.card_custom_price');
  const customizer_additional_charges = document.querySelector('.customizer_additional_charges input');

  if (priceContainers.length === 0) return;

  const basePriceAttr = priceContainers[0].getAttribute('default-price');
  const basePriceStr = basePriceAttr?.replace(/Rs\./i, '').replace(/,/g, '').trim();
  const basePrice = parseFloat(basePriceStr);

  if (isNaN(basePrice)) {
    console.error("Invalid base price:", basePriceAttr);
    return;
  }

  let totalCharges = basePrice;

  document.querySelectorAll('input[type="radio"]:checked').forEach(checkedInput => {
    const charge = parseFloat(checkedInput.getAttribute('more-charges'));
    if (!isNaN(charge)) {
      totalCharges += charge;
    }
  });

  priceContainers.forEach(container => {
    container.innerHTML = `<span>Total: Rs ${totalCharges.toFixed(0)}</span>`;
  });

  cardPriceContainers.forEach(container => {
    container.innerHTML = `<span>Rs. ${totalCharges.toLocaleString()}</span>`;
    container.setAttribute('data-base-price', totalCharges.toLocaleString());
  });
customizer_additional_charges.value = `${totalCharges - basePrice}`;
}

    //   Populate monogram_text into letter inputs
    const monogramText = savedSelections['properties[monogram_text]'];
    if (monogramText) {
      const letterInputs = document.querySelectorAll('.letter-inputs input[name="mono"]');
      const chars = monogramText.replace(/\s+/g, '').split('');

      letterInputs.forEach((input, index) => {
        input.value = chars[index] || '';
                  const apply_mono_btn = document.querySelector(".apply_mono_btn");
        apply_mono_btn.click();
        updatePreview()
      });

      console.log("Monogram populated:", chars.join(' '));
    }

    alert('Previous selection loaded!');
  });
});

// info popup open 
document.querySelectorAll('.info_btn').forEach(button => {
  button.addEventListener('click', () => {

    const targetId = button.getAttribute('data-target')?.replace('#', '');

    document.querySelectorAll('.modal').forEach(modal => {
      if (modal.id === targetId) {

        //   Append the matched modal into the .info-popup element
        const infoPopup = document.querySelector('.info-popup');
        if (infoPopup && !infoPopup.contains(modal)) {
          infoPopup.appendChild(modal);
        }

        modal.classList.add('show');
      } else {
        modal.classList.remove('show');
      }
    });

    const stopscroll = document.querySelector('.customizer_content .product_form_wrapper');
    if (stopscroll) {
      stopscroll.style.overflow = "hidden";
    }

    const adjust_height = document.querySelectorAll('.openchilds');
    adjust_height.forEach(el => {
      el.style.maxHeight = "none";
      el.style.overflow = "hidden";
    });
  });
});


// Handle close button to hide modal
document.querySelectorAll('.close, .close_btn,.modal.fade').forEach(closeBtn => {
  closeBtn.addEventListener('click', () => {
    const targetId = closeBtn.getAttribute('data-target')?.replace('#', '');

    document.querySelectorAll('.modal').forEach(modal => {
      if (modal.id === targetId) {
      }
        modal.classList.remove('show'); // Remove 'show' from matched modal
           const stopscroll = document.querySelector('.customizer_content .product_form_wrapper')
           const stopscroll1 = document.querySelector('.modal.fade')
    console.log("stopscroll1",stopscroll1)
    stopscroll.style.overflow = "auto"
    });
       const adjust_height = document.querySelectorAll('.openchilds');
adjust_height.forEach(el => {
  el.style.maxHeight = "max-content"; // use maxHeight (camelCase) and "none" instead of "auto"
  el.style.overflow = "auto"; // use maxHeight (camelCase) and "none" instead of "auto"
});
  });
});
// open and close size guide popup 
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest(".size-chart-open-popup");
    if (openBtn) {
      console.log("openBtn:", openBtn);
      document.querySelector(".halo-header")?.classList.add("hidden");

      if (openBtn.classList.contains("size-chart-open-popup")) {
        const section = openBtn.closest(".shopify-section");
        section?.querySelector(".custom-model-main")?.classList.add("model-open");
      }

      // .chat-toggle doesn't need modal handling
    }
  });
  document.addEventListener("click", (e) => {
    const closeBtn = e.target.closest(".custom-model-main .close-btn");
    if (closeBtn) {
      document.querySelector(".halo-header")?.classList.remove("hidden");

      const model = closeBtn.closest(".custom-model-main");
      model?.classList.remove("model-open");
    }
  });
});
console.log("new theme")